import React, { Children, FC, useMemo } from 'react'
import Slider, { Settings } from 'react-slick'
import './JSlider.scss'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import { getSliderConfig } from './configs'

export interface JSliderProps extends Settings {

}

export const JSlider: FC<JSliderProps> = props => {
    const config = useMemo(() => Object.keys(props).length === 1 ? getSliderConfig() : props, [props])
    const childrenLength = useMemo(() => Children.toArray(props.children).length, [props.children])
    
    const infinite = useMemo(() => (
        childrenLength <= (config?.slidesToShow || 0) ? false : config.infinite
    ), [props.children])

    const classes = [
        'jcms-slider', 
        `jcms-slider-orientation-${props.vertical ? 'vertical' : 'horizontal'}`,
        `jcms-slider-slides-${childrenLength}`,
        `jcms-slider-slides_to_show-${config?.slidesToShow}`
    ]
    return (
        <Slider
            {...config}
            infinite={infinite}
            className={classes.join(' ')}
            dotsClass="jcms-slider-dots"
        >
            {
                props.children
            }
        </Slider>
    )
}